var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SparkTaskInput_1;
import '@symon-ai/wisepipe-common'; // force import for JsonSchema
import '@symon-ai/wisepipe-usages-domain'; // force import for JsonSchema
import { JSON, JsonDiscriminatorValue, JsonSchema, BeforeDeserialized } from '@symon-ai/wisepipe-serialize';
import { PyJobRequestType, SparkEngineVersion } from '@symon-ai/wisepipe-python-job-domain';
import { ProgressObjectType } from './progress';
import { TaskInput, TaskInputType } from './taskInput';
const schema = {
    $id: 'urn:wisepipe-compute-activity-domain:SparkTaskInput',
    type: 'object',
    properties: {
        stage: { type: 'string', minLength: 1 },
        objectType: { type: 'string', enum: Object.values(ProgressObjectType) },
        pyFile: { $ref: 'urn:wisepipe-common:S3File' },
        usage: { $ref: 'urn:wisepipe-usages-domain:UsageInput' },
        logFile: { $ref: 'urn:wisepipe-common:S3File' },
        sparkEngineVersion: {
            type: 'string',
            enum: Object.values(SparkEngineVersion)
        },
        pyJobRequestType: { type: 'string', enum: Object.values(PyJobRequestType) }
    },
    required: ['pyFile']
};
let SparkTaskInput = SparkTaskInput_1 = class SparkTaskInput extends TaskInput {
    setDefaults() {
        // added to handle progress objects that were created prior to updated progress table schema
        this.stage = 'unknown';
        this.objectType = ProgressObjectType.UNKNOWN;
    }
    constructor(id, orgID, stage = 'unknown', objectType = ProgressObjectType.UNKNOWN, pyFile, usage, orgPlan, logFile, sparkEngineVersion, pyJobRequestType) {
        super(TaskInputType.Spark, id, orgID, orgPlan);
        this.stage = stage;
        this.objectType = objectType;
        this.pyFile = pyFile;
        this.logFile = logFile;
        if (sparkEngineVersion)
            this.sparkEngineVersion = sparkEngineVersion;
        if (usage)
            this.usage = usage;
        if (pyJobRequestType)
            this.pyJobRequestType = pyJobRequestType;
        JSON.validate(this, SparkTaskInput_1);
    }
    static formatRequester(...parts) {
        return parts.join('.');
    }
};
__decorate([
    BeforeDeserialized()
], SparkTaskInput.prototype, "setDefaults", null);
SparkTaskInput = SparkTaskInput_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue(TaskInputType.Spark)
], SparkTaskInput);
export { SparkTaskInput };
//# sourceMappingURL=sparkTaskInput.js.map